<template>
  <v-container fluid class="automated-po-overview pa-0">
    <try-new-atlas-banner :show="showTryNewBanner" @switch="switchToAtlas" />
    <div class="d-flex justify-end px-4 pt-2">
      <copy-link-button />
    </div>

    <!-- Hero Section -->
    <hero-section />
    
    <!-- Workflow Diagram -->
    <workflow-diagram />
    
    <!-- Benefits Grid -->
    <benefits-grid />
    
    
    <!-- Quick Actions -->
    <quick-actions />
    
    <!-- Help Resources -->
    <help-resources />
  </v-container>
</template>

<script>
import TryNewAtlasBanner from '@/components/TryNewAtlasBanner.vue';
import HeroSection from '@/components/automation-overview/HeroSection.vue';
import WorkflowDiagram from '@/components/automation-overview/WorkflowDiagram.vue';
import BenefitsGrid from '@/components/automation-overview/BenefitsGrid.vue';

import QuickActions from '@/components/automation-overview/QuickActions.vue';
import HelpResources from '@/components/automation-overview/HelpResources.vue';
import CopyLinkButton from '@/components/CopyLinkButton.vue';
import { EventHandler } from '@/modules/events';
import { StoreModel } from '@/models/store';
import { getFeatureVersion, setFeatureVersion } from '@/config/atlasFeatures';

export default {
  name: 'AutomatedPOOverview',

  components: {
    HeroSection,
    WorkflowDiagram,
    BenefitsGrid,

    QuickActions,
    HelpResources,
    TryNewAtlasBanner,
    CopyLinkButton
  },
  
  props: {
    store: {
      type: Object,
      default: () => new StoreModel()
    }
  },
  
  data() {
    return {
      loading: false
    };
  },

  computed: {
    showTryNewBanner() {
      return getFeatureVersion('automatedPO') === 'classic';
    }
  },

  mounted() {
    this.trackPageView();
  },

  methods: {
    switchToAtlas() {
      setFeatureVersion('automatedPO', 'atlas');
      this.$router.push('/assistant/automated-po');
    },
    trackPageView() {
      // Track page view for automated PO overview
      const eventHandler = new EventHandler({
        store: this.store,
      });
      eventHandler.trackAutomatedPurchaseOrderStep('Page Viewed', {
        page: 'automated-po-overview'
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.automated-po-overview {
  background-color: #f5f5f5;
  min-height: 100vh;
  
  // Ensure proper spacing between sections
  ::v-deep > div {
    margin-bottom: 48px;
    
    &:last-child {
      margin-bottom: 0;
    }
  }
}

// Responsive adjustments
@media (max-width: 960px) {
  .automated-po-overview {
    ::v-deep > div {
      margin-bottom: 32px;
    }
  }
}
</style> 